function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobiledev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.988
    },
    fill: "#000000",
    d: "M 142.5,-0.5 C 217.833,-0.5 293.167,-0.5 368.5,-0.5C 384.484,3.98523 394.651,14.3186 399,30.5C 399.667,180.5 399.667,330.5 399,480.5C 394.651,496.681 384.484,507.015 368.5,511.5C 293.167,511.5 217.833,511.5 142.5,511.5C 126.516,507.015 116.349,496.681 112,480.5C 111.333,330.5 111.333,180.5 112,30.5C 116.349,14.3186 126.516,3.98523 142.5,-0.5 Z M 151.5,15.5 C 160.525,15.1685 169.525,15.5018 178.5,16.5C 183.333,26.1667 188.167,35.8333 193,45.5C 193.75,46.1258 194.584,46.6258 195.5,47C 235.5,47.6667 275.5,47.6667 315.5,47C 316.416,46.6258 317.25,46.1258 318,45.5C 322.833,35.8333 327.667,26.1667 332.5,16.5C 343.857,15.1738 355.19,15.3404 366.5,17C 376.595,21.0998 382.095,28.5998 383,39.5C 383.667,183.5 383.667,327.5 383,471.5C 381.167,485.333 373.333,493.167 359.5,495C 290.167,495.667 220.833,495.667 151.5,495C 137.333,493.5 129.5,485.667 128,471.5C 127.333,327.5 127.333,183.5 128,39.5C 129.695,25.3065 137.528,17.3065 151.5,15.5 Z M 197.5,15.5 C 236.172,15.1668 274.839,15.5001 313.5,16.5C 311.167,21.1667 308.833,25.8333 306.5,30.5C 272.5,31.8333 238.5,31.8333 204.5,30.5C 201.882,25.5986 199.548,20.5986 197.5,15.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.923
    },
    fill: "#000000",
    d: "M 263.5,116.5 C 268.779,118.037 274.112,119.371 279.5,120.5C 269.315,157.903 258.815,195.237 248,232.5C 247.275,233.059 246.442,233.392 245.5,233.5C 241.138,232.435 236.805,231.268 232.5,230C 231.978,229.439 231.645,228.772 231.5,228C 242.078,190.771 252.745,153.604 263.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.924
    },
    fill: "#000000",
    d: "M 209.5,120.5 C 212.755,122.926 215.588,125.926 218,129.5C 219.289,131.055 219.956,132.721 220,134.5C 202.218,148.299 184.385,161.966 166.5,175.5C 184.385,189.034 202.218,202.701 220,216.5C 219.956,218.279 219.289,219.945 218,221.5C 215.659,224.671 213.159,227.671 210.5,230.5C 188.833,214.333 167.167,198.167 145.5,182C 142.833,177.667 142.833,173.333 145.5,169C 167.081,153.056 188.414,136.889 209.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.925
    },
    fill: "#000000",
    d: "M 299.5,120.5 C 321.619,136.404 343.619,152.571 365.5,169C 368.167,173.333 368.167,177.667 365.5,182C 343.833,198.167 322.167,214.333 300.5,230.5C 297.841,227.671 295.341,224.671 293,221.5C 291.711,219.945 291.044,218.279 291,216.5C 308.782,202.701 326.615,189.034 344.5,175.5C 326.615,161.966 308.782,148.299 291,134.5C 290.333,133.833 290.333,133.167 291,132.5C 294.089,128.646 296.922,124.646 299.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 143.5,255.5 C 154.167,255.5 164.833,255.5 175.5,255.5C 175.5,260.833 175.5,266.167 175.5,271.5C 164.833,271.5 154.167,271.5 143.5,271.5C 143.5,266.167 143.5,260.833 143.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 207.5,255.5 C 260.833,255.5 314.167,255.5 367.5,255.5C 367.5,260.833 367.5,266.167 367.5,271.5C 314.167,271.5 260.833,271.5 207.5,271.5C 207.5,266.167 207.5,260.833 207.5,255.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 143.5,287.5 C 191.5,287.5 239.5,287.5 287.5,287.5C 287.5,292.833 287.5,298.167 287.5,303.5C 239.5,303.5 191.5,303.5 143.5,303.5C 143.5,298.167 143.5,292.833 143.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 319.5,287.5 C 335.5,287.5 351.5,287.5 367.5,287.5C 367.5,292.833 367.5,298.167 367.5,303.5C 351.5,303.5 335.5,303.5 319.5,303.5C 319.5,298.167 319.5,292.833 319.5,287.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 143.5,319.5 C 154.167,319.5 164.833,319.5 175.5,319.5C 175.5,324.833 175.5,330.167 175.5,335.5C 164.833,335.5 154.167,335.5 143.5,335.5C 143.5,330.167 143.5,324.833 143.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 207.5,319.5 C 260.833,319.5 314.167,319.5 367.5,319.5C 367.5,324.833 367.5,330.167 367.5,335.5C 314.167,335.5 260.833,335.5 207.5,335.5C 207.5,330.167 207.5,324.833 207.5,319.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 143.5,351.5 C 191.5,351.5 239.5,351.5 287.5,351.5C 287.5,356.833 287.5,362.167 287.5,367.5C 239.5,367.5 191.5,367.5 143.5,367.5C 143.5,362.167 143.5,356.833 143.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 319.5,351.5 C 335.5,351.5 351.5,351.5 367.5,351.5C 367.5,356.833 367.5,362.167 367.5,367.5C 351.5,367.5 335.5,367.5 319.5,367.5C 319.5,362.167 319.5,356.833 319.5,351.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 143.5,383.5 C 154.167,383.5 164.833,383.5 175.5,383.5C 175.5,388.833 175.5,394.167 175.5,399.5C 164.833,399.5 154.167,399.5 143.5,399.5C 143.5,394.167 143.5,388.833 143.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 207.5,383.5 C 260.833,383.5 314.167,383.5 367.5,383.5C 367.5,388.833 367.5,394.167 367.5,399.5C 314.167,399.5 260.833,399.5 207.5,399.5C 207.5,394.167 207.5,388.833 207.5,383.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#000000",
    d: "M 207.5,463.5 C 239.5,463.5 271.5,463.5 303.5,463.5C 303.5,468.833 303.5,474.167 303.5,479.5C 271.5,479.5 239.5,479.5 207.5,479.5C 207.5,474.167 207.5,468.833 207.5,463.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobiledev);
export default __webpack_public_path__ + "static/media/mobile dev.e1f45ccbfb6ff48e4eb2e3c1a038f2b2.svg";
export { ForwardRef as ReactComponent };